import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { motion } from "framer-motion";

export default function FAQ({ data }) {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 lg:py-32 bg-alabaster">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="overline mb-4" data-testid="faq-overline">{data.overline}</p>
          <h2
            data-testid="faq-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-onyx"
          >
            {data.title}
          </h2>
          {data.subtitle && <p className="mt-4 text-onyx/70">{data.subtitle}</p>}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {(data.items || []).map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-border"
              >
                <AccordionTrigger className="text-left font-serif text-lg sm:text-xl text-onyx hover:text-gold py-6">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-onyx/70 leading-relaxed text-base pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
